import {
  DELETE_STATIONS_CATALOG,
  DELETE_STATIONS_CATALOG_SUCCESS,
  DELETE_STATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteStationsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_STATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_STATIONS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_STATIONS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
